import dayjs from "dayjs";
import React from "react";

interface ComponentProps {
    article: any;
    createdDate: string;
    setChosenPdf: React.Dispatch<React.SetStateAction<string | null>>
    chosenPdf: string | null
    isActive: boolean
}

export default function ArticleCard({ article, createdDate, setChosenPdf, isActive, chosenPdf }: ComponentProps) {
    return (
        <div
            className={`cursor-pointer flex flex-col gap-3 px-4 py-3 rounded-lg mb-2 border ${isActive ? "bg-blue-200 border-blue-400" : "bg-blue-100 border-gray-200"
                } hover:bg-blue-200 transition`}
            onClick={() => setChosenPdf(article.pdf.filename_disk)}
        >
            <h3 className="text-md font-bold text-gray-800 dark:text-white line-clamp-2">
                {article.title}
            </h3>

            {article.writtenBy && article.writtenBy.length > 0 && (
                <div className="flex flex-wrap gap-1 mt-1">
                    {article.writtenBy.map((name: string) => (
                        <span
                            key={name}
                            className="px-2 py-0.5 text-xs text-[#4777b6] font-bold bg-[#f0f6ff]  rounded-full dark:bg-gray-700 dark:text-gray-200">
                            {name}
                        </span>
                    ))}
                </div>
            )}

            {article.title === "Devam Eden Çalışmalar" &&
                <p className="mt-2 block text-sm text-blue-600 dark:text-blue-400 hover:underline">Gözat</p>
            }

            <p className="text-xs text-gray-500 mt-1">
                {dayjs(createdDate).format("DD/MM/YY")}
            </p>
        </div>
    );
}
